import { render } from "./DragDialog.vue?vue&type=template&id=be0d621e&scoped=true"
import script from "./DragDialog.vue?vue&type=script&lang=js"
export * from "./DragDialog.vue?vue&type=script&lang=js"

import "./DragDialog.vue?vue&type=style&index=0&id=be0d621e&scoped=true&lang=css"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be0d621e"]])

export default __exports__